/* eslint-disable */
import post from '../../../../RestAPI/fetchData';
import get from '../../../../RestAPI/getDataService';
import config from '../../../../config/App_data';

const session = JSON.parse(localStorage.getItem('localstorageval')) || {};
const { token, idname } = session;
const payload = {
  token,
  idname,
};
const fetchQuestionsReadingWise = async (data) => {
  return await post.callAPI(
    `${config.backend_api}/gmat-focus/question-bank/getSpecialQuestionByReadingId`,
    { ...payload, ...data },
  );
};
const saveAttemptStats = async (data) => {
  return await post.callAPI(`${config.backend_api}/gmat-focus/question-bank/saveStats`, {
    ...payload,
    ...data,
  });
};

const fetchSavedQuestion = async (data) => {
  return await post.callAPI(`${config.backend_api}/gmat-focus/question-bank/getFavQuestions`, {
    ...payload,
    ...data,
  });
};
const saveQuestion = async (data) => {
  return await post.callAPI(`${config.backend_api}/gmat-focus/question-bank/saveQuestion`, {
    ...payload,
    ...data,
  });
};
const deleteSavedQuestion = async (data) => {
  return await post.callAPI(`${config.backend_api}/gmat-focus/question-bank/unsaveQuestion`, {
    ...payload,
    ...data,
  });
};

const saveReport = async (data) => {
  return await post.callAPI(`${config.backend_api}/gmat-focus/question-bank/reportQuestion`, {
    ...payload,
    ...data,
  });
};
const saveRating = async (data) => {
  return await post.callAPI(`${config.backend_api}/gmat-focus/question-bank/saveGMATRatting`, {
    ...payload,
    ...data,
  });
};

const fetchRating = async (data) => {
  return await post.callAPI(`${config.backend_api}/gmat-focus/question-bank/getGMATRatting`, {
    ...payload,
    ...data,
  });
};

const updateQuestionRating = async (data) => {
  return await post.callAPI(`${config.backend_api}/gmat-focus/question-bank/UpdateGMATRatting`, {
    ...payload,
    ...data,
  });
};

export const apiServices = {
  saveAttemptStats,
  fetchQuestionsReadingWise,
  fetchSavedQuestion,
  saveQuestion,
  deleteSavedQuestion,
  saveReport,
  saveRating,
  fetchRating,
  updateQuestionRating,
};



// WEBPACK FOOTER //
// ./src/views/GMATFocus/QuestionBank/SpecialQuestions/utils/twoStatementServices.js